<script setup lang="ts">

</script>

<template>
  <div class="flex gap-3 bg-white p-4 rounded-lg">
    <div>
      <span class="text-xl">
        ℹ️
      </span>
    </div>
    <div class="text-sm">
      <p class="font-medium">
        Information
      </p>
      <p class="text-muted-foreground">
        Il est rappelé qu'il faut respecter le code de la santé publique : <a
          href="https://www.legifrance.gouv.fr/codes/section_lc/LEGITEXT000006072665/LEGISCTA000006178625/2020-10-05"
          target="_blank"
          class="text-primary font-medium"
        >
          Chapitre V : Déontologie (Articles R4235-1 à R4235-77)
        </a>
      </p>
    </div>
  </div>
</template>

<style scoped>

</style>
